import styled from 'styled-components';
import { Button } from '@insly/qmt-reactjs-ui-lib';

export const InsurersContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  ${({ theme }) => theme.text.h3};
`;

export const InsurersItemStyled = styled.div`
  cursor: grab;
  padding: 1rem;
  border: 2px dashed transparent;
  border-radius: ${({ theme }) => theme.borderRadius};
  background: ${({ theme }) => theme.colors.strokeB};
  transition: 0.3s ease-in-out all;
  
  &.drag-over {
    border-color: ${({ theme }) => theme.colors.black};
  }
`;

export const InsurersControlsBlockStyled = styled.div`
  align-self: end;
  display: flex;
  gap: 0.5rem;
`;

export const ControlButtonStyled = styled(Button)`
  max-width: 150px;
`;

